module.exports = __webpack_public_path__ + "static/media/itronkz.f3fef079.pdf";